// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const APP_VERSION = {
  "buildDateUTC": "Thu, 25 Jun 2026 23:24:15 GMT",
  "packageVersion": "5.6.3",
  "commitSha": "c16e2e1fb6513b32443cba6dc2030042a9030fda",
  "branch": "kemal/ne-17524-recording-autostop-fix"
};
/* eslint:enable */